export var Constant;
(function (Constant) {
    let SendType;
    (function (SendType) {
        SendType[SendType["ACK"] = 0] = "ACK";
        SendType[SendType["HEARBEAT"] = 1] = "HEARBEAT";
        SendType[SendType["MSG"] = 2] = "MSG";
        SendType[SendType["LOGIN"] = 3] = "LOGIN";
        SendType[SendType["LOGINOUT"] = 4] = "LOGINOUT";
        SendType[SendType["REQUEST"] = 7] = "REQUEST";
        SendType[SendType["PULL"] = 8] = "PULL";
        SendType[SendType["FRIENDLAST"] = 9] = "FRIENDLAST";
        SendType[SendType["PULLRESPONSE"] = 10] = "PULLRESPONSE";
        SendType[SendType["CALLEVENT"] = 21] = "CALLEVENT";
        SendType[SendType["CALLEVENTOPT"] = 22] = "CALLEVENTOPT";
        SendType[SendType["MSG_READ_STATUS"] = 24] = "MSG_READ_STATUS"; //消息已读回执
    })(SendType = Constant.SendType || (Constant.SendType = {}));
    let ACKTimes;
    (function (ACKTimes) {
        ACKTimes[ACKTimes["ACK_TIMES"] = 3] = "ACK_TIMES";
    })(ACKTimes = Constant.ACKTimes || (Constant.ACKTimes = {}));
})(Constant || (Constant = {}));
//# sourceMappingURL=constant.js.map